import React from 'react';
import { useFormikContext } from 'formik';
import { observer } from 'mobx-react';

import { useStore } from 'core/store/';
import { Discount } from '../discount';

const ConnectedHomeDiscount = observer(({ isActive, ...discount }) => {
  const { offer: store } = useStore();
  const { setShowConnectedHomeModal, showConectedHomeModal, includeConnectedHome } = store;
  const { setFieldValue, values } = useFormikContext();

  const onAddClick = () => {
    if (values.connectedHome === null) {
      setFieldValue('connectedHome', {
        moistureDevices: undefined,
        motionDetectingDevices: undefined,
        smokeDetectingDevices: undefined,
        theftPreventionDevices: undefined,
        autoWaterShutoffDevices: false,
        providerName: undefined,
        ...values.connectedHome
      });
    }
    setShowConnectedHomeModal(true);
  };

  const connectedHomeInfo = { includeConnectedHome, showConectedHomeModal, connectedHomeValues: values.connectedHome };

  return (
    <Discount {...discount} isActive={isActive} onAdd={onAddClick} canEdit connectedHomeInfo={connectedHomeInfo} />
  );
});

export default ConnectedHomeDiscount;
